
import React from "react";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";

type ServiceShareHeaderProps = {
  isSavingLink: boolean;
  onNavigateToDashboard: () => void;
};

export const ServiceShareHeader: React.FC<ServiceShareHeaderProps> = ({ 
  isSavingLink, 
  onNavigateToDashboard 
}) => {
  return (
    <div className="text-center mb-8">
      <h1 className="text-4xl font-bold mb-4 text-gebeya-pink">
        Share Your Service Page
      </h1>
      <p className="text-gray-600 text-lg mb-6">
        Make your services visible on social media and attract more clients.
      </p>
      
      <Button
        onClick={onNavigateToDashboard}
        className="w-full bg-gradient-to-r from-gebeya-pink to-gebeya-orange text-white hover:opacity-90 flex gap-2 items-center justify-center h-14 text-lg font-semibold shadow-md hover:shadow-lg transition-all transform hover:scale-[1.02] rounded-xl mb-8"
      >
        Proceed to Dashboard
        <ArrowRight className="w-5 h-5" />
      </Button>
      
      {isSavingLink && (
        <p className="text-sm text-gebeya-pink mt-2">Saving your service page link...</p>
      )}
    </div>
  );
};
